import { post, get, patch, deleted } from "services";
import routes from "./routes";

const SupplierServices = {
  addSupplier: async (obj) => {
    const data = await post(routes.addSupplier, obj);
    return data;
  },
  editSupplier: async (obj) => {
    const data = await patch(routes.editSupplier, obj);
    return data;
  },
  getSupplier: async (obj) => {
    const data = await get(routes.getSupplier, obj);
    return data;
  },
  getSupplierDetail: async (obj) => {
    const data = await get(routes.getSupplierDetail, obj);
    return data;
  },
  addBill: async (obj) => {
    const data = await post(routes.addBill, obj);
    return data;
  },
  editBill: async (obj) => {
    const data = await patch(routes.editBill, obj);
    return data;
  },
  getBill: async (obj) => {
    const data = await get(routes.getBill, obj);
    return data;
  },
  getBillDetails: async (obj) => {
    const data = await get(routes.getBillDetails, obj);
    return data;
  },
  getBillDetailsPreview: async (obj) => {
    const data = await get(routes.getBillDetailsPreview, obj);
    return data;
  },
  approveBill: async (obj) => {
    const data = await patch(routes.approveBill, obj);
    return data;
  },
deleteBill: async (obj) => {
  const data = await deleted(routes.deleteBill, null, obj);
  return data;
},
deletePaidBill: async (obj) => {
  const data = await deleted(routes.deletePaidBill, null, obj);
  return data;
},
  payBill: async (obj) => {
    const data = await post(routes.payBill, obj);
    return data;
  },
};

export default SupplierServices;
